<template>
  <v-app>
    <v-main v-if="!loading">
      <navbar :notifications="notifications" v-if="$route.path !== '/login' && !$route.path.includes('/classes/manage/dictation/single/show')"></navbar>
      <global-snack-bar class="snackbar-text"></global-snack-bar>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import GlobalSnackBar from "@/components/Notification/GlobalSnackBar";
import Navbar from "@/components/Navbar/Navbar";
import Echo from "laravel-echo";


export default {
  name: 'App',
  components: {Navbar, GlobalSnackBar},
  watch: {
    $route(to, from) {
      this.trackActivity(to, from)
    }
  },
  data: () => ({
    userType : null,
    loading: true,
    notifications: [],
    lastTrackedPath: null,
  }),
  async beforeMount() {
    if (this.$cookies.get('userType') === 'admin') {
      this.userType = "admins"
    } else {
      this.userType = "instructors"
    }
    await this.getProfile()
    this.initialWS()
    this.initialListenWs()
    this.getNotifications()
  },
  methods: {
    initialWS() {
      if (!this.$store.state.user) {
        return
      }
      this.$store.state.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'myKey',
        cluster: 'mt1',
        wsHost: process.env.VUE_APP_WS_HOST,
        wsPort: process.env.VUE_APP_WS_PORT,
        forceTLS: process.env.VUE_APP_FORCE_TLS !== 'false',
        disableStats: true,
        encrypted: true,
        auth: {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        },
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              window.mainAxios.post('/api/' + this.userType + '/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
                  .then(response => {
                    callback(false, response.data);
                  })
                  .catch(error => {
                    console.log('error dadam.')
                    callback(true, error);
                  });
            }
          };
        },
      });
      this.$store.state.loadingEcho = false
    },
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.notification.' + this.$store.state.user.id)
            .listen('SendNotification', (e) => {
              console.log(e)
              this.getNotifications()
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.notification.' + self.$store.state.user.id)
              .listen('SendNotification', (e) => {
                console.log(e.data.data, 'Socket delayed')
                self.getNotifications()
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
    getNotifications() {
      window.axios.get('instructor/notification/index/unseen').then((res) => {
        this.notifications = res.data.data
      })
    },
    activityEndpoint() {
      return this.userType === 'admins' ? 'admin/activity/track' : 'instructor/activity/track'
    },
    activityTitle(route) {
      const path = route?.path || ''
      if (path === '/dashboard') return 'ورود به داشبورد'
      if (path === '/profile') return 'ورود به صفحه پروفایل'
      if (path === '/otp/index') return 'ورود به گزارش ورود'
      if (path === '/activities/index') return 'ورود به صفحه فعالیت ها'
      if (path === '/sms/index') return 'ورود به پنل پیامکی'
      if (path === '/notifications/my') return 'ورود به اعلان های من'
      if (path === '/notifications/index') return 'ورود به صفحه اعلان ها'
      if (path === '/logs/index') return 'ورود به صفحه لاگ ها'
      if (path === '/students/index') return 'ورود به لیست هنرجویان'
      if (path.startsWith('/students/get/')) return 'ورود به صفحه مشاهده هنرجو'
      if (path.startsWith('/students/edit/')) return 'ورود به صفحه ویرایش هنرجو'
      if (path === '/teachers/index') return 'ورود به لیست اساتید'
      if (path.startsWith('/teachers/edit/')) return 'ورود به صفحه ویرایش استاد'
      if (path === '/courses/index') return 'ورود به لیست دوره ها'
      if (path === '/courses/create') return 'ورود به صفحه ساخت دوره'
      if (path === '/school/index') return 'ورود به مدیریت آموزشگاه ها'
      if (path === '/permission-and-role/role/index') return 'ورود به صفحه دسترسی ها'
      if (path === '/messages/index') return 'ورود به صفحه پیام ها'
      if (path === '/messages/create') return 'ورود به صفحه ارسال پیام'
      if (path === '/tickets/index') return 'ورود به صفحه تیکت ها'
      if (path === '/subscription/index') return 'ورود به مدیریت اشتراک ها'
      return route?.meta?.activityTitleFa || route?.name || path || 'ورود به صفحه ناشناخته'
    },
    trackActivity(route = this.$route) {
      if (!this.$store.state.auth || !this.$store.state.user || !route) {
        return
      }
      if (route.path === '/login') {
        return
      }
      if (route.path === this.lastTrackedPath) {
        return
      }
      this.lastTrackedPath = route.path
      window.axios.post(this.activityEndpoint(), {
        title_fa: this.activityTitle(route),
        route_name: route.name || null,
        route_path: route.path || null,
      }).catch(() => {})
    },
    async getProfile() {
      if (this.$store.state.user) {
        this.$store.state.user = null
      }
      if (!this.$cookies.get('userType')) {
        if (this.$route.path !== '/login') {
          await this.$router.push('/login')
        }
        this.loading = false
      }
      if (this.$cookies.get('userType') === 'admin') {
        await window.axios.get('admin/auth/profile').then((res) => {
          this.$store.state.user = res.data.data
          this.$store.state.auth = true
          this.$store.state.loading = false
          this.loading = false
          this.trackActivity(this.$route)
          if (this.$route.path === '/login') {
            this.$router.push('/')
          }
        }).catch(() => {
          if (this.$route.path !== '/login')
            this.$router.push('/login')

          this.loading = false
        })
      }
      if (this.$cookies.get('userType') === 'instructor') {
        await window.axios.get('instructor/auth/profile').then((res) => {
          this.$store.state.user = res.data.data
          this.$store.state.auth = true
          this.$store.state.loading = false
          this.loading = false
          this.trackActivity(this.$route)
          if (this.$route.path === '/login') {
            this.$router.push('/')
          }
        }).catch(() => {
          if (this.$route.path !== '/login')
            this.$router.push('/login')
          this.loading = false
        })
      }
    }
  }
};
</script>
<style>
@font-face {
  font-family: Vazir;
  src: url("../src/assets/fonts/vazir/Vazir.ttf");
}
@font-face {
  font-family: 'Roboto';
  src: url('../public/assets/fonts/roboto/Roboto-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

* {
  font-family: Vazir, serif;
}

@media (max-width: 960px) {
  .v-main {
    overflow-x: hidden;
  }

  .v-main .mt-8,
  .v-main .mx-8 {
    margin-top: 8px !important;
    margin-left: 8px !important;
    margin-right: 8px !important;
  }

  .v-card {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }

  .v-dialog {
    width: calc(100% - 24px) !important;
    max-width: calc(100% - 24px) !important;
    margin: 12px !important;
  }

  .v-data-table > .v-data-table__wrapper {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .v-data-table table {
    min-width: 760px;
  }

  .v-navigation-drawer {
    max-width: calc(100% - 24px) !important;
  }

  .v-main .v-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .v-main .v-row > [class*="col-"] {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .v-main table {
    display: block;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
  }

  .v-main img,
  .v-main video {
    max-width: 100% !important;
    height: auto !important;
  }

  .v-main .mr-16,
  .v-main .ml-16 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .v-input,
  .v-select,
  .v-autocomplete,
  .v-text-field,
  .v-btn {
    width: 100%;
  }

  .v-card__actions {
    flex-wrap: wrap;
  }

  .v-main [style*="left:49vw"] {
    left: auto !important;
    right: 12px !important;
  }
}
</style>
